<h1 mat-dialog-title>
    <span translate>ndf.creation.title</span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <list-view [liste]="liste" *ngIf="liste"></list-view>
</div>
